import React from 'react';
import { Field, MultiSelectInput } from './form';

export const DEPARTMENT_LEVELS = [['ELEM', '초등'], ['MIDDLE', '중등'], ['HIGH', '고등']];
export const departmentLevelsLabel = (levels = []) => DEPARTMENT_LEVELS.filter(([key]) => levels.includes(key)).map(([, label]) => label).join('·') || '없음';

export default function DepartmentLevelsField({ value, onChange }) {
  return <Field label="부서 자동 선택 기준" hint="여러 학교급을 고를 수 있습니다. 모두 해제하면 기준 없음으로 저장합니다.">
    <MultiSelectInput aria-label="부서 자동 선택 기준" value={value} onChange={onChange} options={DEPARTMENT_LEVELS} placeholder={value.length ? '학교급 추가' : '없음 — 학교급 선택'} />
  </Field>;
}
